import React, {useState} from 'react';

import css from './PeriodsComponent.module.css';
import {ButtonCreate} from "../../../ui/ButtonCreate/ButtonCreate";
import {PeriodsCreatePeriodModal} from "../settingSectionModals/PeriodsCreatePeriodModal/PeriodsCreatePeriodModal";
import PeriodsListComponent from "../PeriodsListComponent/PeriodsListComponent";


const PeriodsComponent = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(true);
    };


    return (
        <section className={css.wrap}>

            <section className={css.btnBlock}>
                <ButtonCreate onClick={handleClick}/>
            </section>

            <section className={css.listBlock}>
                <PeriodsListComponent/>
            </section>

            {isOpen && <PeriodsCreatePeriodModal setIsOpen={setIsOpen}/>}
            {/*{isOpenUpdate && <PeriodsUpdatePeriodModal setIsOpenUpdate={setIsOpenUpdate}/>}*/}
        </section>
    );
};

export {PeriodsComponent};